import { OrderedList } from "@tiptap/extension-list";

export const CustomizedOrderedList = OrderedList.extend({
  addAttributes() {
    const attributes = { ...this.parent?.() };
    // Circle supports numeric lists only. Drop pasted alphabetic/Roman types
    // when ProseMirror parses HTML or creates nodes from the paste handler's JSON.
    // TODO: Revisit this restriction when app validation and renderers support "a", "A", "i", and "I" lists.
    delete attributes.type;
    return attributes;
  },
});
